import './About.css'
import React from 'react'
import { Link } from 'react-router-dom';
import picture1 from '../Images/picture1.jpg';
import picture2 from '../Images/picture2.jpg'
import resume from '../Images/Sharanya_Resume_website.pdf'

const AboutContent = () => {
  return (
    <div className='about'>
      <div className='left'>
        <h1>About me.</h1>
        As a dedicated software engineer with a Bachelor's degree from Atria Institute of Technology, I've cultivated a strong foundation in computer science and engineering.<br />

        <br />My expertise spans Java, Python, JavaScript, and C++, alongside web technologies like HTML5, CSS3, and React.js. Proficient in both frontend and backend development, I've worked with frameworks like Redux.js, Next.js, Node.js, and Express.js. I'm adept in database management systems such as MongoDB and MySQL.

        I've undertaken several projects like PlacePicker and iDonate, showcasing my ability to develop dynamic web applications using modern tech stacks like MERN.<br />

        <br />Beyond technical skills, I actively engage in continuous learning, participating in coding challenges on platforms like LeetCode and GeeksforGeeks. I hold certifications as a Full Stack Developer from GeeksforGeeks and top-tier ratings in SQL and problem-solving from Hackerrank.

        As a detail-oriented team player, I excel in fast-paced environments and seek opportunities to contribute to innovative projects, leveraging my expertise in software development and problem-solving to drive impactful outcomes.<br />
        {/* <a href={resume} download className='btn'>Download CV</a> */}
        <Link to="/contact">
          <button className='btn'>Contact me</button>
        </Link>

      </div>
    </div>
  )
}

export default AboutContent